'use strict';

// Custom Knockout binding that makes elements shown/hidden via jQuery's fadeIn()/fadeOut() methods
ko.bindingHandlers.fadeVisible = {
    init: function init(element, valueAccessor) {
        // Initially set the element to be instantly visible/hidden depending on the value
        var value = valueAccessor();
        $(element).toggle(ko.unwrap(value)); // Use "unwrapObservable" so we can handle values that may or may not be observable
    },
    update: function update(element, valueAccessor) {
        // Whenever the value subsequently changes, slowly fade the element in or out
        var value = valueAccessor();
        ko.unwrap(value) ? $(element).fadeIn() : $(element).fadeOut();
    }
};

// Custom Knockout binding to handle the display of currency
ko.bindingHandlers.currency = {
    symbol: ko.observable('$'),
    update: function update(element, valueAccessor, allBindingsAccessor) {
        $(element).hide();
        ko.bindingHandlers.text.update(element, function () {
            var value = +(ko.utils.unwrapObservable(valueAccessor()) || 0),
                symbol = ko.utils.unwrapObservable(allBindingsAccessor().symbol === undefined ? allBindingsAccessor().symbol : ko.bindingHandlers.currency.symbol);
            return symbol + value.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        });
        $(element).fadeIn();
    }
};

ko.bindingHandlers.fadeInText = {
    update: function update(element, valueAccessor) {
        $(element).hide();
        ko.bindingHandlers.text.update(element, valueAccessor);
        $(element).fadeIn();
    }
};

// Formats given input as integer number of minutes (including "mm:ss", integer, decimal or exponential form).
// See http://knockoutjs.com/documentation/extenders.html
ko.extenders.durationMinutes = function (target) {
    //create a writable computed observable to intercept writes to our observable
    var result = ko.pureComputed({
        read: target, //always return the original observables value
        write: function write(newValue) {
            var current = target();

            var lengthMinutes = isNaN(newValue) ? 0 : Math.ceil(newValue); // handles decimal and int value, ceiling it by our business rules

            // Parsing minutes with seconds
            var lengthPattern = /(\d+)(:(\d{2}))?/;
            var lengthParsed = lengthPattern.exec(newValue);
            if (lengthParsed !== null) {
                if (typeof lengthParsed[3] !== 'undefined') lengthMinutes = ++lengthParsed[1]; // just ceil minutes if seconds part given
            }

            var valueToWrite = lengthMinutes > 0 ? lengthMinutes : '';

            // only write if it changed and has value
            if (valueToWrite !== current && valueToWrite !== '') target(valueToWrite);else target(newValue); // write as-is, looks like custom input is in progress

            target.notifySubscribers(valueToWrite); // notify about change (validation, etc)
        }
    }).extend({ notify: 'always' });

    // initialize with current value to make sure it is rounded appropriately
    result(target());

    // return the new computed observable
    return result;
};

// http://stackoverflow.com/questions/12342435/bootstrap-popover-with-content-from-template
// http://stackoverflow.com/questions/17710788/knockoutjs-v2-3-0-error-you-cannot-apply-bindings-multiple-times-to-the-same-e
ko.bindingHandlers.popover = {
    init: function init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var attribute = ko.utils.unwrapObservable(valueAccessor());
        var htmlContent = '';

        if (attribute.template) {
            var temp = $('<div>');
            ko.applyBindingsToNode(temp[0], { template: { name: attribute.template, data: viewModel } });
            htmlContent = temp.html();
            temp.remove();
        } else {
            htmlContent = attribute.contentSelector ? $(attribute.contentSelector).html() : attribute.content;
        }

        var popoverContentWrapperId = attribute.wrapper + '-popover-content-wrapper';
        var popOverTemplate = '<div id="' + popoverContentWrapperId + '"></div>';
        var $element = $(element);

        $element.popover({
            content: popOverTemplate,
            html: true,
            trigger: attribute.trigger || 'manual',
            container: attribute.container != null ? attribute.container : false,
            placement: attribute.placement || 'bottom'
        });
        $element.attr('id', popoverContentWrapperId + '-click');

        // if a specific trigger has not been defined, define an "onClick" one
        if (!attribute.trigger) {
            $element.click(function (e) {
                e.stopPropagation();
                $element.popover('toggle');
                setTimeout(function () {
                    var thePopover = $('#' + popoverContentWrapperId)[0];
                    $(thePopover).html(htmlContent);
                    var childBindingContext = bindingContext.createChildContext(viewModel);
                    ko.cleanNode(thePopover); //hakish internal API call
                    ko.applyBindingsToDescendants(childBindingContext, thePopover);
                }, 50);
            });
        }
    }
};